module.exports = __webpack_public_path__ + "static/media/video-thumbnail-desktop-es.72dbfc8e.png";